import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";

export const StyledFortnoxSettings = styled.div``;
export const StyledFortnoxSettingsInnerCard = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	padding: 16px;
	gap: 0.25rem;
	/* display: flex;
	flex-wrap: wrap;
		align-items: stretch; */
`;

const StyledSettingsItem = styled(NavLink)<{
	backgroundColor?: string;
}>`
	background-color: ${({ backgroundColor }) => backgroundColor || "transparent"};
	transition: opacity 0.2s ease-in-out, background-color 0.2s ease-in-out, filter 0.2s ease-in-out;
	flex: 1;
	padding: 20px;
	/* font-size: 1rem; */
	font-weight: 400;
	/* line-height: 2rem; */
	color: var(--textColor);
	cursor: pointer;
	border-radius: 6px;
	text-decoration: none;
	column-gap: 1rem;
	row-gap: 0.25rem;

	display: grid;
	grid-template-columns: 4rem 1fr;
	grid-template-areas: "icon title" "icon description";
	grid-template-rows: max-content;

	/* min-width: 300px;   */
	/* max-width: 500px; */

	&:hover {
		color: var(--textColor);
	}

	${({ backgroundColor }) =>
		backgroundColor
			? css`
					&:hover {
						filter: brightness(1.5);
					}
			  `
			: css`
					&:hover {
						background-color: rgba(0, 0, 0, 0.25);
					}
			  `}
`;

const StyledSettingsItemTitle = styled.p`
	grid-area: title;
	font-weight: 700;
`;
const StyledSettingsItemDescription = styled.p`
	grid-area: description;
	color: #637381;
	font-size: 0.95em;
`;
const StyledSettingsItemIcon = styled.div`
	grid-area: icon;
	width: 4rem;
	height: 4rem;
	fill: #919eab;

	display: flex;
	justify-content: center;

	.Polaris-Icon,
	.Polaris-Spinner {
		margin: 0;
		margin-top: 0.5rem;
	}
`;

interface StyledSettingsItemType {
	Title: typeof StyledSettingsItemTitle;
	Description: typeof StyledSettingsItemDescription;
	Icon: typeof StyledSettingsItemIcon;
}

const SettingsItem: StyledSettingsItemType | any = StyledSettingsItem;
SettingsItem.Title = StyledSettingsItemTitle;
SettingsItem.Description = StyledSettingsItemDescription;
SettingsItem.Icon = StyledSettingsItemIcon;
export { SettingsItem };
